<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <b-row class="mobile-justify">
            <b-col cols="3" md="3" class="desktop">
                <div class="profile-card text-center">
                    <img :src="getAvatar" alt="">
                    <p>{{profileData.first_name}} {{profileData.last_name}}</p>
                   
                    <div v-if="isPublicProfile" class="w-500 font12 mb-2">
                        <p>{{profileData.bio}} </p>
                        <b-form-rating readonly show-value inline size="sm" v-model="profileData.rating"></b-form-rating>
                    </div>

                    <b-list-group class="mt-3" v-if="isPersonalProfile">
                        <b-list-group-item v-bind:class="{ 'active' : isSelected(0) }" v-on:click="selected = 0" href="#" v-scroll-to="'#personal-photo'">General Info </b-list-group-item>
                    </b-list-group>
                    <b-list-group class="mt-3" v-if="isBusinessProfile">
                        <b-list-group-item v-bind:class="{ 'active' : isSelected(0) }" v-on:click="selected = 0" href="#" v-scroll-to="'#business-info'">Business Info </b-list-group-item>
                    </b-list-group>

                </div>

            </b-col>
            <div class="text-center mobile">
                <div class="profile-card">
                    <img :src="getAvatar" alt="">
                </div>

            </div>
            <b-col cols="12" md="9">
                <b-row class="head-box text-center">
                    <b-col cols="12" md="4" @click="showPersonalProfile" :class="isPersonalProfile == true ? 'active':''" class="inner-header-box">
                        <b-icon icon="person"></b-icon> Personal Profile
                    </b-col>
                    <b-col cols="12" md="4" @click="showBusinessProfile" :class="isBusinessProfile == true ? 'active':''" class="inner-header-box">
                        <b-icon icon="bag"></b-icon> Business Profile
                    </b-col>
                    <b-col cols="12" md="4" @click="showPublicProfile" :class="isPublicProfile == true ? 'active':''" class="inner-header-box">
                        <b-icon icon="globe"></b-icon> Public Profile
                    </b-col>
                </b-row>
                <p class="mb-4 mt-4">Personal Info </p>
                <div class="shadow-container" v-if="isPersonalProfile">
                    <form @submit.prevent="updateProfile('Saving...')" action="">
                        <p id="personal-photo">Profile Photo </p>
                        <div class="file-container mb-4">
                            <p>Upload Profile Image</p>
                            <div @click="openProfileImg" class="btn btn-warning">Choose File
                                <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                            </div>
                            <b-form-file @change="showFileName" style="visibility:hidden" id="profileImg" class="mt-3" plain></b-form-file><span>{{filename}}</span>
                        </div>

                        <p>General Info </p>
                        <b-row class="mt-4">
                            <b-form-group class="col-md-6 mb-4" label-for="firstName">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="person"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="profileData.first_name" placeholder="First Name"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="lastName">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="person"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="profileData.last_name" placeholder="Last Name"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="Username">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="person"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" v-model="currentUser.username" readonly placeholder="Username"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="email">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="envelope"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input readonly type="email" v-model="currentUser.email" placeholder="Email"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                <select class="mb-3 custom-select" required v-model="nationality_id" @change="countryChange">
                                    <option value="null" selected disabled>Please select nationality</option>
                                    <option v-for="(country, index) in countries" :key="index" :value="country.country_id">
                                        {{ country.name }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                <select class="mb-3 custom-select" required v-model="gender" @change="genderChange">
                                    <option value="null" selected disabled>Please select gender</option>
                                    <option v-for="(gender, index) in genders" :key="index" :value="gender.name">
                                        {{ gender.name }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="dob">
                                <date-picker v-model="profileData.dob" valueType="format" format="YYYY-MM-DD" placeholder="Date of Birth" id="dob" type="date"></date-picker>
                             
                            </b-form-group>
                        </b-row>
                        <p id="personal-contact">Contact Info </p>

                        <b-row class="mt-1">
                            <b-form-group class="col-md-6 mb-4" label-for="phone">
                                <vue-tel-input @validate="numberChanged" required v-bind="bindProps" class="form-control mb-1" v-model="phone"></vue-tel-input>
                                <small style="color: #7f7f7f;">Enter number without international format (+)</small>
                            </b-form-group>

                            <b-form-group class="col-md-6 mb-4" label-for="address">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="globe"></b-icon>
                                    </b-input-group-prepend>
                                    <vue-google-autocomplete id="m-map" required ref="address" classname="form-control" placeholder="Enter an address or location" v-on:placechanged="getAddressData" v-model="profileData.address">
                                    </vue-google-autocomplete>
                                </b-input-group>
                            </b-form-group>

                        </b-row>
                        <p id="personal-profile">Profile Info</p>
                        <b-row class="mt-4 mb-3">
                            <div class="col-md-6">
                                <b-form-group class="mb-3" label-for="input-1">
                                    <textarea required rows="5" v-model="profileData.bio" placeholder="Profile Bio" class="shadow form-control"></textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group class=" mb-4" label-for="input-1">
                                    <b-input-group class="">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="tag"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="profileData.activities" type="text" placeholder="Occupation"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class=" mb-4" label-for="input-1">
                                    <b-input-group class="">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="tag"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="profileData.interests" type="text" placeholder="Hobbies"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="desktop col-md-12 mb-3" label-for="input-1">
                                    <div @click="saveContinue" class="float-right btn btn-warning"> {{saveContinueText}}
                                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                                    </div>
                                </b-form-group>
                                <b-form-group class="desktop  col-md-12 mb-3" label-for="input-1">
                                    <button class="float-right mr-2 btn btn-warning">
                                        <b-icon icon="file-lock"></b-icon> {{saveText}}
                                    </button>
                                </b-form-group>

                                <b-form-group class="mobile col-md-12 mb-3" label-for="input-1">
                                    <button class="btn btn-warning">{{saveText}}
                                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                                    </button>
                                </b-form-group>
                            </div>
                        </b-row>
                    </form>
                    <div v-if="profileData.has_onboarded === 'Yes'">
                        <p id="personal-contact">Payment Info </p>
                        <b-row class="mb-4">
                            <div class="col-md-12">
                                <div @click="viewWallet" class="btn btn-warning">View Wallet Balance
                                    <b-icon scale="0.8" icon="money"></b-icon>
                                </div>
                            </div>
                        </b-row>
                    </div>

                    <div class="mt-5 text-center">
                        <b-row align-h="center">
                            <b-col cols="12" md="6">
                                Your information is always kept encrypted and can never be accessed by third
                                parties. View our <span @click="openPolicy" style="cursor: pointer" class="culture-primary"> Privacy Policy</span>

                            </b-col>

                        </b-row>
                    </div>

                </div>
                <div class="shadow-container" v-if="isBusinessProfile">
                    <p id="business-photo">Profile Photo </p>
                    <form @submit.prevent="handleBusinessProfile" action="">
                        <div class="file-container mb-4">
                            <p>Upload Business Image</p>
                            <div @click="openBusinessImage" class="btn btn-warning">Choose File
                                <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                            </div>
                            <b-form-file @change="showBusinessImage" style="visibility:hidden" id="businessImg" class="mt-3" plain></b-form-file><span>{{bizImgname}}</span>
                        </div>
                        <p id="business-info">Business Info </p>
                        <b-row class="mt-4">
                            <b-form-group class="col-md-6 mb-4" label-for="name">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="bag"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="businessData.name" placeholder="Business Name"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="bag"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="businessData.reg_no" placeholder="Registration Number"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="envelope"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="email" required v-model="businessData.email" placeholder="Email"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            
                        </b-row>
                        <p id="business-contact">Contact Info </p>
                        <b-row>
                            <b-form-group class="col-md-6 mb-4" label-for="phone">
                                <vue-tel-input @validate="businessNumberChanged" required v-bind="bindProps" class="form-control" v-model="businessPhone"></vue-tel-input>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="address">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="globe"></b-icon>
                                    </b-input-group-prepend>
                                    <vue-google-autocomplete id="bmap" :required="businessData.address == null" ref="businessAddress" classname="form-control" placeholder="Enter an address or location" v-on:placechanged="getBusinessAddressData" v-model="businessData.address">
                                    </vue-google-autocomplete>
                                </b-input-group>
                            </b-form-group>

                        </b-row>
                        <p id="business-docs">Business Documents</p>
                        <b-row>
                            <b-form-group class="col-md-6 mb-4" label-for="document">
                                <select :required="businessData.doc_type == null" class="mb-3 custom-select" v-model="document" @change="docChange">
                                    <option value="" selected disabled>Please select document</option>
                                    <option v-for="(doc, index) in business_documents" :key="index" :value="doc">
                                        {{ doc.name }}
                                    </option>
                                </select>
                            </b-form-group>

                            <div class="col-md-12">
                                <div class="file-container mb-4">
                                    <p>Upload Business Document</p>
                                    <div @click="openBusinessFile" class="btn btn-warning">Choose File
                                        <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                                    </div>
                                    <b-form-file @change="showBusinessDocName" style="visibility:hidden" id="businessDoc" class="mt-3" plain></b-form-file><span>{{bizDoc}}</span>
                                </div>
                                <b-form-group v-if="businessData.bizfile" class=" mb-4" label-for="doc_name">
                                    <a class="culture-secondary" @click="openBusinessFiles" href="#">
                                        <b-icon font-scale="4" icon="file-earmark-zip"></b-icon>
                                    </a>
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <p id="business-docs">Services</p>
                                <div class="row" v-for="(service, index) in businessData.services" :key="index">
                                    <b-form-group class="col-md-10 mb-4" label-for="service_name">
                                        <b-input-group class="">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="tag"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input type="text" v-model="service.title" placeholder="service title"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-1">
                                        <b-icon style="cursor: pointer" @click="removeService(index)" v-if="index>=1" shift-v="-15" icon="trash"></b-icon>
                                    </b-form-group>
                                </div>
                                <b-row>
                                    <b-col>
                                        <div @click="addService" class="btn btn-secondary">+ Add </div>
                                    </b-col>
                                </b-row>
                                <b-form-group class="desktop col-md-12 mb-3" label-for="input-1">
                                    <button class="float-right btn btn-warning">
                                        <b-icon icon="file-lock"></b-icon> {{saveText}}
                                    </button>
                                </b-form-group>
                                <b-form-group class="mobile col-md-12 mb-3" label-for="input-1">
                                    <button class="btn btn-warning">
                                        <b-icon icon="file-lock"></b-icon> {{saveText}}
                                    </button>
                                </b-form-group>

                            </div>
                            <div class="mt-5 text-center">
                                <b-row align-h="center">
                                    <b-col cols="6">
                                        Your information is always kept encrypted and can never be accessed by third
                                        parties. View our <span @click="openPolicy" style="cursor: pointer" class="culture-primary"> Privacy Policy</span>

                                    </b-col>

                                </b-row>
                            </div>
                        </b-row>
                    </form>
                </div>
                <div class="public-container" v-if="isPublicProfile">
                    <p>Personal Info </p>
                    <div class="row p-3">
                        <div class="col-md-6" v-if="profileData.gender">
                            <p class="font12 mb-3">Gender</p>
                            <p class="mb-3 text-capitalize">
                                <b-icon icon="person"></b-icon> {{profileData.gender}}
                            </p>
                        </div>
                        <div class="col-md-6" v-if="profileData.nationality">
                            <p class="font12 mb-3">Nationality</p>
                            <p class="mb-3">
                                <b-icon icon="globe"></b-icon> {{profileData.nationality.name}}
                            </p>
                        </div>
                        <div class="col-md-6" v-if="profileData.state_residence">
                            <p class="font12 mb-3">State of Residence</p>
                            <p class="mb-3">
                                <b-icon icon="globe"></b-icon> {{profileData.state_residence}}
                            </p>
                        </div>
                        <div class="col-md-6" v-if="profileData.city_residence">
                            <p class="font12 mb-3">City of Residence</p>
                            <p class="mb-3">
                                <b-icon icon="globe"></b-icon> {{profileData.city_residence}}
                            </p>
                        </div>
                        <div class="col-md-6" v-if="profileData.country_residence">
                            <p class="font12 mb-3">Resident Country</p>
                            <p class="mb-3">
                                <b-icon icon="globe"></b-icon> {{profileData.country_residence}}
                            </p>
                        </div>
                        <div class="col-md-6" v-if="profileData.activities">
                            <p class="font12 mb-3">Occupation</p>
                            <p class="mb-3">
                                <b-icon icon="bag"></b-icon> {{profileData.activities}}
                            </p>
                        </div>
                        <div class="col-md-6">
                            <p class="font12 mb-3">Joined</p>
                            <p class="mb-3">
                                <b-icon icon="clock"></b-icon> {{profileData.created_at | moment(" MMMM YYYY")}}
                            </p>
                        </div>
                        <div class="col-md-6" v-if="businessData">
                            <p class="font12 mb-3">Business Name</p>
                            <p class="mb-3">
                                <b-icon icon="bag"></b-icon> {{businessData.name}}
                            </p>
                        </div>
                    </div>

                </div>
            </b-col>
        </b-row>

    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import Activation from "@/components/Activation.vue";
import axios from "axios";
// import moment from "moment";

import {
    getBaseUrl
} from "../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'profile',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Footer,
        Activation,
        DatePicker,
        VueGoogleAutocomplete
    },
    data: function () {
        return {
            headerText: "Your Profile",
            subText: "Keep your profile updated to stay connected ",
            fadedText: "Profile",
            saveText: "Save",
            saveContinueText:'Save & Continue',
            defaultImage: require("../assets/images/prof-img.png"),
            selected: 0,
            countries: [],
            filename: '',
            nationality_id: '',
            maxdate: new Date(),
            bindProps: {
                mode: "international",
                placeholder: "Enter a phone number",
                name: "telephone",
                autoDefaultCountry: false
            },
            bizImgname: '',
            bizDoc: '',
            gender: '',
            document: '',
            genders: [{
                    id: 1,
                    name: "male"
                },
                {
                    id: 2,
                    name: "female"
                },
                {
                    id: 3,
                    name: "other"
                }
            ],
            business_documents: [{
                    id: 1,
                    name: 'Business License'
                },
                {
                    id: 2,
                    name: 'Vendor Identity Document'
                },
                {
                    id: 3,
                    name: 'Bank Statement'
                },
                {
                    id: 4,
                    name: 'Tax EIN document'
                },
            ],
            profileData: {
                first_name: '',
                last_name: '',
                email: '',
                username: '',
                nationality: '',
                nationality_id: '',
                gender: '',
                photo: '',
                phone: '',
                address: '',
                activities: '',
                bio: '',
                interests: '',
                country_residence: '',
                state_residence: '',
                city_residence: '',
            },
            phone: '',
            businessPhone: '',
            businessData: {
                name: '',
                email: '',
                reg_no: '',
                phone: '',
                address: '',
                business_id: '',
                tax_rate: '',
                doc_type_id: '',
                doc_type: '',
                services: [],
            },
            isPersonalProfile: true,
            isBusinessProfile: false,
            isPublicProfile: false,
            listingTypeSelected: null,
        }
    },
    mounted() {
        this.getCountries();
        this.getUserProfile();
    },
    computed: {
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
        getAvatar: function () {
            return (this.profileData.photo_full) ? this.profileData.photo_full : this.defaultImage
        },
    },
    methods: {
        openPolicy() {
            let routeData = this.$router.resolve({
                name: 'policy'
            });
            window.open(routeData.href, "_blank")
        },
        addService() {
            if (this.businessData.services === null) {
                this.businessData.services = [{}];
                return;
            }
            this.businessData.services.push({
                title: ""
            })
        },
        removeService(index) {
            this.businessData.services.splice(index, 1);
        },
        openBusinessFiles() {
            window.open(this.businessData.bizfile, "_blank")
        },
        async viewWallet() {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/stripe`,
                    method: "GET",
                })
                const stripe_url = resp.data.stripe_account_login
                alert(resp.data.message)
                window.open(stripe_url, "_blank") || window.location.replace(stripe_url);
            } catch (error) {
                this.$root.$refs.A.makeToast('warning', error.response.data.message)
            }

        },
        async getUserProfile() {
            try {
                const resp = await this.$store.dispatch("getProfile")
                this.profileData = Object.assign({}, resp.data.data);
                this.businessData = Object.assign({}, resp.data.business_profile);
                this.phone = this.profileData.phone ? this.profileData.phone : ''
                this.nationality_id = this.profileData.nationality ? this.profileData.nationality.country_id : null
                this.gender = this.profileData.gender
                // this.profileData.dob = moment(this.profileData.dob).format("MM-DD-YYYY");
                this.businessPhone = this.businessData.phone
            } catch (error) {
                console.warn(error.response.data.message);
            }
        },
        getAddressData: function (_addressData, placeResultData) {
            if (placeResultData.formatted_address !== null) {
                this.profileData.address = placeResultData.formatted_address;
                this.profileData.country_residence = _addressData.country
                this.profileData.state_residence = _addressData.administrative_area_level_1
                this.profileData.city_residence = _addressData.locality
            }
        },
        getBusinessAddressData: function (addressData, placeResultData) {
            if (placeResultData.formatted_address !== null) {
                this.businessData.address = placeResultData.formatted_address;
                this.businessData.country_residence = addressData.country
                this.businessData.state_residence = addressData.administrative_area_level_1
                this.businessData.city_residence = addressData.locality
                this.businessData.lat = addressData.latitude
                this.businessData.long = addressData.longitude
            }
        },
        numberChanged: function ({
            number
        }) {
            this.profileData.phone = number
        },
        businessNumberChanged: function ({
            number
        }) {
            this.businessData.phone = number
        },
        openProfileImg() {
            document.getElementById('profileImg').click()
        },
        showFileName() {
            const file = document.getElementById("profileImg").files[0];
            this.filename = file.name
        },
        showBusinessImage() {
            const file = document.getElementById("businessImg").files[0];
            this.bizImgname = file.name
        },
        showBusinessDocName() {
            const file = document.getElementById("businessDoc").files[0];
            this.bizDoc = file.name
        },
        openBusinessImage() {
            document.getElementById('businessImg').click()
        },
        openBusinessFile() {
            document.getElementById('businessDoc').click()
        },
        isSelected(i) {
            return i === this.selected
        },
        countryChange() {
            this.profileData.nationality_id = this.nationality_id
        },
        genderChange() {
            this.profileData.gender = this.gender
        },
        docChange() {
            this.businessData.doc_type_id = this.document.id
            this.businessData.doc_type = this.document.name
        },
        showPersonalProfile() {
            this.isPersonalProfile = true;
            this.isBusinessProfile = false;
            this.isPublicProfile = false;
        },
        showBusinessProfile() {
            this.isPersonalProfile = false;
            this.isBusinessProfile = true;
            this.isPublicProfile = false;
        },
        showPublicProfile() {
            this.isPersonalProfile = false
            this.isBusinessProfile = false
            this.isPublicProfile = true
        },
        selectedOption(option) {
            if (this.value) {
                return option.name === this.value.name;
            }
            return false;
        },
        async getCountries() {
            try {
                const resp = await axios.get(`${base_url}/api/v2/countries`)
                this.countries = resp.data.data;
            } catch (error) {
                console.warn(error.response.data.message);
            }
        },
        async updateProfile(savingText) {
            const image = document.getElementById("profileImg").files[0]
            let data = new FormData();
            if (image) {
                data.append("photo", document.getElementById("profileImg").files[0]);
            }
            data.append('first_name', this.profileData.first_name)
            data.append('last_name', this.profileData.last_name)
            data.append('nationality_id', this.nationality_id)
            data.append('gender', this.profileData.gender)
            data.append('phone', this.profileData.phone)
            data.append('address', this.profileData.address)
            data.append('bio', this.profileData.bio)
            data.append('dob', this.profileData.dob)
            data.append('personal_activities', this.profileData.activities)
            data.append('interests', this.profileData.interests)
            data.append('country_residence', this.profileData.country_residence)
            data.append('state_residence', this.profileData.state_residence)
            data.append('city_residence', this.profileData.city_residence)
            if (this.profileData.phone) {
                this.saveText = savingText;
                try {
                    const resp = await this.$store.dispatch("updateProfile", data)
                    this.saveText = 'Save';
                    this.$root.$refs.A.makeToast('success', resp.data.message)
                    this.profileData = resp.data.data;
                    //this.profileData.dob = moment(this.profileData.dob).format("MM-DD-YYYY")
                    return true;
                } catch (error) {
                    this.saveText = 'Save';
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                    return false;
                }
            } else {
                this.saveText = 'Save';
                this.$root.$refs.A.makeToast('warning', 'phone number is required')
                return false
            }
        },
        handleBusinessProfile() {
            if (this.businessData.business_id === undefined) {
                this.createBusinessProfile();
            } else {
                this.updateBusinessProfile();
            }
        },
        async createBusinessProfile() {
            const image = document.getElementById("businessImg").files[0]
            const doc = document.getElementById("businessDoc").files[0]
            if (this.businessData.phone) {
                let data = new FormData();
                if (image) {
                    data.append("image", document.getElementById("businessImg").files[0]);
                }
                if (doc) {
                    data.append("bizfile", document.getElementById("businessDoc").files[0]);
                }
                data.append('name', this.businessData.name)
                data.append('phone', this.businessData.phone)
                data.append('reg_no', this.businessData.reg_no)
                data.append('address', this.businessData.address)
                data.append('email', this.businessData.email)
                data.append('country_residence', this.businessData.country_residence)
                data.append('state_residence', this.businessData.state_residence)
                data.append('city_residence', this.businessData.city_residence)
                data.append('tax_rate', this.businessData.tax_rate)
                data.append('doc_type_id', this.businessData.doc_type_id)
                data.append('doc_type', this.businessData.doc_type)
                data.append('lat', this.businessData.lat)
                data.append('long', this.businessData.long)
                if (this.businessData.services.length > 0) {
                    for (let i = 0; i < this.businessData.services.length; i++) {
                        for (let key of Object.keys(this.businessData.services[i])) {
                            data.append(`services[${i}][${key}]`, this.businessData.services[i][key]);
                        }
                    }
                }
                this.saveText = 'Saving...';
                try {
                    const resp = await this.$store.dispatch("createBusinessProfile", data)
                    this.saveText = 'Save';
                    this.$root.$refs.A.makeToast('success', resp.data.message)
                    this.businessData = resp.data.data;
                    this.getUserProfile();
                } catch (error) {
                    this.saveText = 'Save';
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            }
            else {
                this.saveText = 'Save';
                this.$root.$refs.A.makeToast('warning', 'business phone number is required')
            } 
        },
        async updateBusinessProfile() {
            const businessId = this.businessData.business_id
            const image = document.getElementById("businessImg").files[0]
            const doc = document.getElementById("businessDoc").files[0]
            let data = new FormData();
            if (image) {
                data.append("image", document.getElementById("businessImg").files[0]);
            }
            if (doc) {
                data.append("bizfile", document.getElementById("businessDoc").files[0]);
            }
            data.append('name', this.businessData.name)
            data.append('phone', this.businessData.phone)
            data.append('reg_no', this.businessData.reg_no)
            data.append('address', this.businessData.address)
            data.append('email', this.businessData.email)
            data.append('country_residence', this.businessData.country_residence)
            data.append('state_residence', this.businessData.state_residence)
            data.append('city_residence', this.businessData.city_residence)
            data.append('tax_rate', this.businessData.tax_rate)
            data.append('doc_type_id', this.businessData.doc_type_id)
            data.append('doc_type', this.businessData.doc_type)
            data.append('lat', this.businessData.lat)
            data.append('long', this.businessData.long)

            for (let i = 0; i < this.businessData.services.length; i++) {
                for (let key of Object.keys(this.businessData.services[i])) {
                    data.append(`services[${i}][${key}]`, this.businessData.services[i][key]);
                }
            }
            this.saveText = 'Saving...';
            try {
                const resp = await this.$store.dispatch("updateBusinessProfile", {
                    data: data,
                    businessId: businessId
                })
                this.saveText = 'Save';
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.businessData = resp.data.data;
                this.getUserProfile();
            } catch (error) {
                this.saveText = 'Save';
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async saveContinue() {
            this.saveContinueText = 'Saving...'
            const update = await this.updateProfile('Save');
            if (update) {
                this.$router.push('/dashboard');
            }
            else {
                this.saveContinueText = 'Save & Continue'
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.file-container {
    padding: 20px 30px 30px 20px;
    background: #fff;
}

.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 17px 16px;
    border: none;
    height: 59px;
    width: 100%;
}

.input-group {
    border-radius: 8px !important;
    height: 58px;
    margin: 0 !important
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 15px) !important;

}

.textbox {
    padding: 20px;
    border-radius: 8px !important;
}

.shadow {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.input-group-text {
    border-radius: 8px 0 0 8px !important;
    padding: 1.2rem 2px 1.2rem 1rem !important
}

.btn-culture {
    padding: 10px 60px !important;
}

.public-container {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 0px 0px 16px 16px;
    padding: 30px 30px 60px 30px;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select.caret {
    padding-right: 100px;
}

.custom-control {
    margin: 20px auto
}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box.active {
    background: #000;
    color: #fff;
    border-radius: 4px;
}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
}

.vti__input {
    background: #f8f9fa !important;
}

textarea.form-control {
    height: 8.7rem !important;
}

.form-control[readonly] {
    background-color: #fff !important;
}

.profile-card {
    margin: 35px auto auto;
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;

    @media screen and (min-device-width: 340px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }

}

.profile-card img {
    border-radius: 50%;
    height: 111px;
    width: 111px
}

.profile-card p {
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: #565C63;
    text-transform: capitalize;
    margin-top: 20px
}

@media screen and (min-device-width: 340px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
    .mobile-justify {
        justify-content: center;
        margin-right: -15px !important;
    }
}
</style>
